// Shared config for the Product Line Settings card + form. Owns the row order and
// the shape both the display and the form iterate over.

// Rows in the settings table, in display order.
export const PER_LINE_SETTINGS = [
  { key: "iAllowableDuration", label: "Allowable Duration", type: "number", unit: "Days" },
  { key: "bAllowsNinetyDaySupply", label: "Allows 90 Day Supply", type: "checkbox" },
  { key: "iCapitated", label: "Capitated Duration", type: "number", unit: "Months" },
  { key: "bRequiresCompliance", label: "Requires Compliance", type: "checkbox" },
  { key: "bCountsMaskAsSeal", label: "Counts Mask As Seal", type: "checkbox" },
  { key: "bCMNRequired", label: "CMN Required", type: "checkbox" }
];

// Settings that don't apply to the CGM product line. Cells render as "N/A" in both the display
// card and the edit form; backend read paths ignore whatever value is stored on the CGM row.
export const CGM_NOT_APPLICABLE_SETTING_KEYS = new Set([
  "bRequiresCompliance",
  "bCountsMaskAsSeal",
  "bCMNRequired"
]);

// Whether a (line, setting) cell is meaningful. Currently the CGM column is N/A for three
// PAP-only clinical settings; extend as needed if a future product line has its own exclusions.
export const isSettingApplicableToLine = (fkiProductLine, settingKey) =>
  !(fkiProductLine === 2 && CGM_NOT_APPLICABLE_SETTING_KEYS.has(settingKey));

// Falls back to an empty array when hcpcs is still loading so the display / form don't
// crash on the transient null.
export const buildProductLinesFromHcpcs = hcpcs => hcpcs?.productLines ?? [];

// Default productLines[] payload for "Add Insurance" (no hcpcs response yet). Backend
// looks up each row by fkiProductLine — when a new product line lands, add a row here
// (and to the backend's PRODUCT_LINES concept).
export const buildDefaultProductLines = () => [
  {
    fkiProductLine: 1,
    productLineName: "CPAP",
    iAllowableDuration: 0,
    bAllowsNinetyDaySupply: true,
    iCapitated: 0,
    bRequiresCompliance: true,
    bCountsMaskAsSeal: true,
    bCMNRequired: true
  },
  {
    fkiProductLine: 2,
    productLineName: "CGM",
    iAllowableDuration: 0,
    bAllowsNinetyDaySupply: true,
    iCapitated: 0,
    bRequiresCompliance: true,
    bCountsMaskAsSeal: true,
    bCMNRequired: true
  }
];
